import { z } from 'zod';
import { xml2ast, allHtmlParsers } from '@utils/ast';
import { baseTaskSchema } from '../schema.base.js';
import { onImageFractionInput } from './input.fraction.js';
import { onImageReadonlyInput } from './input.readonly.js';
import { onImageTextInput } from './input.text.js';

const writeAnswersOnImageTaskSchema = baseTaskSchema.extend({
  taskType: z.literal("WriteAnswers"),
  answerType: z.literal("OnImage"),
  answerGroups: z.record(z.string(), z.array(z.string())).default({}),
  backgroundImage: z.string(),
  backgroundAltText: z.string().nullish().default(null),
  backgroundLongDescription: z.string().nullish().default(null).transform(it => it ? xml2ast(it, allHtmlParsers, "text/html") : null),
  textFields: z.array(z.union([onImageReadonlyInput.schema, onImageTextInput.schema, onImageFractionInput.schema])),
  settings: z.object({
    scaleFactor: z.number().default(1)
  }).default({})
}).transform(({
  answerGroups,
  backgroundImage,
  textFields,
  ...rest
}) => ({
  ...rest,
  backgroundImageSrc: backgroundImage,
  content: textFields.map((input, inputIndex) => {
    switch (input.type) {
      case "Fraction":
        return onImageFractionInput.postprocessSchemaInput(input, {
          taskId: rest.id,
          index: inputIndex
        });
      case "ReadOnly":
        return onImageReadonlyInput.postprocessSchemaInput(input, {
          taskId: rest.id,
          index: inputIndex
        });
      case "Writeable":
        return onImageTextInput.postprocessSchemaInput(input, {
          answerGroups,
          taskId: rest.id,
          index: inputIndex
        });
    }
  })
}));

export { writeAnswersOnImageTaskSchema };
//# sourceMappingURL=_schema.js.map
